import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "./logo.png";
import "./App.css";
import "./Style.css";
import { HashLink } from "react-router-hash-link";

import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth, db } from "./firebase";
import { doc, getDoc } from "firebase/firestore";

export default function Top() {
  const [user, setUser] = useState(null);
  const [companyName, setCompanyName] = useState("ASIAN CLIMATE CONTROLS");
  const navigate = useNavigate();

  // 🔐 Listen to login / logout
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });

    fetchCompanyName();

    return () => unsubscribe();
  }, []);

  const fetchCompanyName = async () => {
    try {
      const snap = await getDoc(doc(db, "COMPANY_PROFILE", "main_profile"));
      if (snap.exists()) {
        setCompanyName(snap.data().companyName || "ASIAN CLIMATE CONTROLS");
      }
    } catch (err) {
      console.error("Error fetching company name:", err);
    }
  };

  // 🚪 Logout handler
  const handleLogout = async () => {
    await signOut(auth);
    navigate("/EmpLogin");
  };

  return (
    <nav className="navbar navbar-expand-sm bg-dark navbar-dark fixed-top">
      <div className="container-fluid">

        {/* Logo + Company Name */}
        <Link
          to="/"
          className="navbar-brand d-flex align-items-center"
          style={{ textDecoration: "none" }}
        >
          <img src={logo} alt="Company Logo" className="logo me-2" />
          <span className="brand-text text-white">
            {companyName}
          </span>
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapsibleNavbar"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="collapsibleNavbar">
          <ul className="navbar-nav ms-auto">


            {/* Home Link */}
            <li className="nav-item">
              <Link className="nav-link" to="/">
                Home
              </Link>
            </li>

            {/* Contact */}
            <li className="nav-item">
              <HashLink smooth className="nav-link" to="/#contact">
                Contact Us
              </HashLink>
            </li>

            {/* LOGIN / LOGOUT DROPDOWN */}
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
              >
                {user ? "Account" : "Login"}
              </a>

              <ul className="dropdown-menu dropdown-menu-end">
                {user ? (
                  <li>
                    <button
                      className="dropdown-item text-danger"
                      onClick={handleLogout}
                    >
                      Logout
                    </button>
                    <Link to="/AdminDashboard" className="dropdown-item">
                      Dashboard
                    </Link>
                  </li>
                ) : (
                  <li>
                    <Link to="/EmpLogin" className="dropdown-item">
                      Login
                    </Link>
                  </li>
                )}
              </ul>
            </li>

          </ul>
        </div>
      </div>
    </nav>
  );
}
